module.exports = __webpack_public_path__ + "img/bg-3.92ece5fb.jpg";